<app-button 
    #mobileBtn
    [class]="{'hidden': !showElement()}"
    [classList]="'opacity-0'"
    [type]="buttonType"
    [custom]="['dark-button']"
    [active]="service.active()"
    (event)="service.toggleButton()"
>

    <svg ngProjectAs="icon" class="text-current size-4 transition-transform" [class]="{'rotate-45': service.active()}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="2 2 20 20" stroke-width="2.2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
    </svg>

</app-button>
